export const CasePhaseConstants = {
    PHASE_1: "Phase1",
    PHASE_2: "Phase2"
} as const;